import { SeuCalculationResponseApi } from '@seu-types';

export const SEU_MOCK_CALC_RESPONSE: SeuCalculationResponseApi = [
  {
    globalParameterSetId: 1459,
    interconnectionId: 10602,
    operatingConditionId: 10529,
    streams: [
      {
        streamId: 1,
        canvasStreamId: '617714f3-0591-4023-a92e-8ab4748e371b',
        generalData: [
          {
            name: 'Temperature',
            aggregateState: 'NONE',
            unitValues: [
              {
                unit: 'gradC',
                value: 200.0,
              },
              {
                unit: 'gradK',
                value: 473.15,
              },
            ],
            defaultUnit: 'gradC',
          },
          {
            name: 'Pressure',
            aggregateState: 'NONE',
            unitValues: [
              {
                unit: 'Pa_abs',
                value: 101325.0,
              },
              {
                unit: 'mmH2O_rel',
                value: 0.0,
              },
              {
                unit: 'atm',
                value: 1.0,
              },
              {
                unit: 'mbar_abs',
                value: 1013.25,
              },
              {
                unit: 'mbar_rel',
                value: 0.0,
              },
              {
                unit: 'Pa_rel',
                value: 0.0,
              },
            ],
            defaultUnit: 'Pa_rel',
          },
          {
            name: 'VolumeFlow',
            aggregateState: 'NONE',
            unitValues: [
              {
                unit: 'Nm3_fe_h',
                value: 75000.0,
              },
              {
                unit: 'Bm3_tr_h',
                value: 114325.1,
              },
              {
                unit: 'Nm3_tr_h',
                value: 66000.0,
              },
              {
                unit: 'Bm3_fe_h',
                value: 129914.88,
              },
            ],
            defaultUnit: 'Nm3_fe_h',
          },
          {
            name: 'MassFlow',
            aggregateState: 'NONE',
            unitValues: [
              {
                unit: 'mg_s',
                value: 2.6220348e7,
              },
              {
                unit: 'g_h',
                value: 9.4393256e7,
              },
              {
                unit: 'mg_h',
                value: 9.439325e10,
              },
              {
                unit: 'kg_h',
                value: 94393.25,
              },
              {
                unit: 'kg_s',
                value: 26.22,
              },
            ],
            defaultUnit: 'kg_s',
          },
          {
            name: 'Enthalpy',
            aggregateState: 'NONE',
            unitValues: [
              {
                unit: 'MW',
                value: 11.17,
              },
              {
                unit: 'kW_kg',
                value: 426.03,
              },
              {
                unit: 'kW',
                value: 11170.44,
              },
            ],
            defaultUnit: 'kW',
          },
        ],
        gasMainComp: [
          {
            name: 'CO2',
            aggregateState: 'AGGREGATE_STATE_GAS',
            unitValues: [
              {
                unit: 'mg_s',
                value: 2045320.4,
              },
              {
                unit: 'vol_fe',
                value: 5.0,
              },
              {
                unit: 'mg_h',
                value: 7.3631534e9,
              },
              {
                unit: 'mass_percent',
                value: 7.801,
              },
              {
                unit: 'g_h',
                value: 7363153.5,
              },
              {
                unit: 'kg_h',
                value: 7363.15,
              },
              {
                unit: 'vol_tr',
                value: 5.682,
              },
              {
                unit: 'kg_s',
                value: 2.045,
              },
            ],
            defaultUnit: 'vol_fe',
          },
          {
            name: 'H2O',
            aggregateState: 'AGGREGATE_STATE_GAS',
            unitValues: [
              {
                unit: 'mg_s',
                value: 2009907.2,
              },
              {
                unit: 'vol_fe',
                value: 12.0,
              },
              {
                unit: 'mg_h',
                value: 7.2356664e9,
              },
              {
                unit: 'g_kg',
                value: 0.7665,
              },
              {
                unit: 'mass_percent',
                value: 7.665,
              },
              {
                unit: 'g_h',
                value: 7235666.5,
              },
              {
                unit: 'kg_h',
                value: 7235.67,
              },
              {
                unit: 'vol_tr',
                value: 0.0,
              },
              {
                unit: 'kg_s',
                value: 2.01,
              },
            ],
            defaultUnit: 'vol_fe',
          },
          {
            name: 'N2',
            aggregateState: 'AGGREGATE_STATE_GAS',
            unitValues: [
              {
                unit: 'mg_s',
                value: 1.7703618e7,
              },
              {
                unit: 'vol_fe',
                value: 68.0,
              },
              {
                unit: 'mg_h',
                value: 6.3733023e10,
              },
              {
                unit: 'mass_percent',
                value: 67.52,
              },
              {
                unit: 'g_h',
                value: 6.373302e7,
              },
              {
                unit: 'kg_h',
                value: 63733.02,
              },
              {
                unit: 'vol_tr',
                value: 77.27,
              },
              {
                unit: 'kg_s',
                value: 17.7,
              },
            ],
            defaultUnit: 'vol_fe',
          },
          {
            name: 'O2',
            aggregateState: 'AGGREGATE_STATE_GAS',
            unitValues: [
              {
                unit: 'mg_s',
                value: 4461503.5,
              },
              {
                unit: 'vol_fe',
                value: 15.0,
              },
              {
                unit: 'mg_h',
                value: 1.6061412e10,
              },
              {
                unit: 'mass_percent',
                value: 17.02,
              },
              {
                unit: 'g_h',
                value: 1.6061412e7,
              },
              {
                unit: 'kg_h',
                value: 16061.41,
              },
              {
                unit: 'vol_tr',
                value: 17.05,
              },
              {
                unit: 'kg_s',
                value: 4.462,
              },
            ],
            defaultUnit: 'vol_fe',
          },
        ],
        gasSideComp: [
          {
            name: 'solids',
            aggregateState: 'AGGREGATE_STATE_SOLID',
            unitValues: [],
            defaultUnit: 'mg_Nm3_fe_betrO2',
          },
        ],
        otherData: [
          {
            name: 'Density',
            aggregateState: 'NONE',
            unitValues: [
              {
                unit: 'kg_Bm3',
                value: 0.7266,
              },
              {
                unit: 'kg_Nm3',
                value: 1.259,
              },
            ],
            defaultUnit: null,
          },
          {
            name: 'Conductivity',
            aggregateState: 'NONE',
            unitValues: [],
            defaultUnit: null,
          },
          {
            name: 'DynamicViscosity',
            aggregateState: 'NONE',
            unitValues: [
              {
                unit: 'Pas',
                value: 2.501e-5,
              },
            ],
            defaultUnit: null,
          },
          {
            name: 'KinematicViscosity',
            aggregateState: 'NONE',
            unitValues: [
              {
                unit: 'm2_s',
                value: 3.442e-5,
              },
            ],
            defaultUnit: null,
          },
          {
            name: 'HeatCapacityMixture',
            aggregateState: 'NONE',
            unitValues: [],
            defaultUnit: null,
          },
        ],
      },
      {
        streamId: 2,
        canvasStreamId: 'd2ab379d-e4c5-4008-b29c-d2a8487201dd',
        generalData: [
          {
            name: 'Temperature',
            aggregateState: 'NONE',
            unitValues: [
              {
                unit: 'gradC',
                value: 200.0,
              },
              {
                unit: 'gradK',
                value: 473.15,
              },
            ],
            defaultUnit: 'gradC',
          },
          {
            name: 'Pressure',
            aggregateState: 'NONE',
            unitValues: [
              {
                unit: 'Pa_abs',
                value: 101325.0,
              },
              {
                unit: 'mmH2O_rel',
                value: 0.0,
              },
              {
                unit: 'atm',
                value: 1.0,
              },
              {
                unit: 'mbar_abs',
                value: 1013.25,
              },
              {
                unit: 'mbar_rel',
                value: 0.0,
              },
              {
                unit: 'Pa_rel',
                value: 0.0,
              },
            ],
            defaultUnit: 'Pa_rel',
          },
          {
            name: 'VolumeFlow',
            aggregateState: 'NONE',
            unitValues: [
              {
                unit: 'Nm3_fe_h',
                value: 75000.0,
              },
              {
                unit: 'Bm3_tr_h',
                value: 114325.1,
              },
              {
                unit: 'Nm3_tr_h',
                value: 66000.0,
              },
              {
                unit: 'Bm3_fe_h',
                value: 129914.88,
              },
            ],
            defaultUnit: 'Nm3_fe_h',
          },
          {
            name: 'MassFlow',
            aggregateState: 'NONE',
            unitValues: [
              {
                unit: 'mg_s',
                value: 2.6220348e7,
              },
              {
                unit: 'g_h',
                value: 9.4393256e7,
              },
              {
                unit: 'mg_h',
                value: 9.439325e10,
              },
              {
                unit: 'kg_h',
                value: 94393.25,
              },
              {
                unit: 'kg_s',
                value: 26.22,
              },
            ],
            defaultUnit: 'kg_s',
          },
          {
            name: 'Enthalpy',
            aggregateState: 'NONE',
            unitValues: [
              {
                unit: 'MW',
                value: 11.17,
              },
              {
                unit: 'kW_kg',
                value: 426.03,
              },
              {
                unit: 'kW',
                value: 11170.44,
              },
            ],
            defaultUnit: 'kW',
          },
        ],
        gasMainComp: [
          {
            name: 'CO2',
            aggregateState: 'AGGREGATE_STATE_GAS',
            unitValues: [
              {
                unit: 'mg_s',
                value: 2045320.4,
              },
              {
                unit: 'vol_fe',
                value: 5.0,
              },
              {
                unit: 'mg_h',
                value: 7.3631534e9,
              },
              {
                unit: 'mass_percent',
                value: 7.801,
              },
              {
                unit: 'g_h',
                value: 7363153.5,
              },
              {
                unit: 'kg_h',
                value: 7363.15,
              },
              {
                unit: 'vol_tr',
                value: 5.682,
              },
              {
                unit: 'kg_s',
                value: 2.045,
              },
            ],
            defaultUnit: 'vol_fe',
          },
          {
            name: 'H2O',
            aggregateState: 'AGGREGATE_STATE_GAS',
            unitValues: [
              {
                unit: 'mg_s',
                value: 2009907.2,
              },
              {
                unit: 'vol_fe',
                value: 12.0,
              },
              {
                unit: 'mg_h',
                value: 7.2356664e9,
              },
              {
                unit: 'g_kg',
                value: 0.7665,
              },
              {
                unit: 'mass_percent',
                value: 7.665,
              },
              {
                unit: 'g_h',
                value: 7235666.5,
              },
              {
                unit: 'kg_h',
                value: 7235.67,
              },
              {
                unit: 'vol_tr',
                value: 0.0,
              },
              {
                unit: 'kg_s',
                value: 2.01,
              },
            ],
            defaultUnit: 'vol_fe',
          },
          {
            name: 'N2',
            aggregateState: 'AGGREGATE_STATE_GAS',
            unitValues: [
              {
                unit: 'mg_s',
                value: 1.7703618e7,
              },
              {
                unit: 'vol_fe',
                value: 68.0,
              },
              {
                unit: 'mg_h',
                value: 6.3733023e10,
              },
              {
                unit: 'mass_percent',
                value: 67.52,
              },
              {
                unit: 'g_h',
                value: 6.373302e7,
              },
              {
                unit: 'kg_h',
                value: 63733.02,
              },
              {
                unit: 'vol_tr',
                value: 77.27,
              },
              {
                unit: 'kg_s',
                value: 17.7,
              },
            ],
            defaultUnit: 'vol_fe',
          },
          {
            name: 'O2',
            aggregateState: 'AGGREGATE_STATE_GAS',
            unitValues: [
              {
                unit: 'mg_s',
                value: 4461503.5,
              },
              {
                unit: 'vol_fe',
                value: 15.0,
              },
              {
                unit: 'mg_h',
                value: 1.6061412e10,
              },
              {
                unit: 'mass_percent',
                value: 17.02,
              },
              {
                unit: 'g_h',
                value: 1.6061412e7,
              },
              {
                unit: 'kg_h',
                value: 16061.41,
              },
              {
                unit: 'vol_tr',
                value: 17.05,
              },
              {
                unit: 'kg_s',
                value: 4.462,
              },
            ],
            defaultUnit: 'vol_fe',
          },
        ],
        gasSideComp: [
          {
            name: 'solids',
            aggregateState: 'AGGREGATE_STATE_SOLID',
            unitValues: [],
            defaultUnit: 'mg_Nm3_fe_betrO2',
          },
        ],
        otherData: [
          {
            name: 'Density',
            aggregateState: 'NONE',
            unitValues: [
              {
                unit: 'kg_Bm3',
                value: 0.7266,
              },
              {
                unit: 'kg_Nm3',
                value: 1.259,
              },
            ],
            defaultUnit: null,
          },
          {
            name: 'Conductivity',
            aggregateState: 'NONE',
            unitValues: [],
            defaultUnit: null,
          },
          {
            name: 'DynamicViscosity',
            aggregateState: 'NONE',
            unitValues: [
              {
                unit: 'Pas',
                value: 2.501e-5,
              },
            ],
            defaultUnit: null,
          },
          {
            name: 'KinematicViscosity',
            aggregateState: 'NONE',
            unitValues: [
              {
                unit: 'm2_s',
                value: 3.442e-5,
              },
            ],
            defaultUnit: null,
          },
          {
            name: 'HeatCapacityMixture',
            aggregateState: 'NONE',
            unitValues: [],
            defaultUnit: null,
          },
        ],
      },
    ],
    components: [
      {
        componentId: 12729,
        componentType: 'addCodes',
        componentInputStreamId: 'd2ab379d-e4c5-4008-b29c-d2a8487201dd',
        componentOutputStreamId: '617714f3-0591-4023-a92e-8ab4748e371b',
        solutionsPerSection: [],
        codes: ['I098101'],
      },
    ],
    globalCodes: ['I000416', 'I000411'],
    opex: {
      unit: 'euro_per_year',
      value: 163000.0,
    },
    emissionLimits: [
      {
        type: 'Pressure',
        value: [],
      },
      {
        type: 'VolumeFlow',
        value: [
          {
            unit: 'Nm3_fe_h',
            value: 76361.62,
          },
          {
            unit: 'Bm3_tr_h',
            value: 116400.67,
          },
          {
            unit: 'Nm3_tr_h',
            value: 67198.23,
          },
          {
            unit: 'Bm3_fe_h',
            value: 132273.48,
          },
        ],
      },
      {
        type: 'Enthalpy',
        value: [
          {
            unit: 'MW',
            value: 12.54,
          },
          {
            unit: 'kW_kg',
            value: 478.16,
          },
          {
            unit: 'kW',
            value: 12537.31,
          },
        ],
      },
      {
        type: 'Temperature',
        value: [
          {
            unit: 'gradC',
            value: 190.0,
          },
          {
            unit: 'gradK',
            value: 453.15,
          },
        ],
      },
      {
        type: 'MassFlow',
        value: [],
      },
    ],
  },
];
